import UpgradeSuccessContainer from "../../Component/UpgradeSuccess/UpgradeSuccess";



const UpgradeSuccess = () => {
  return (
    <div className="page-body">
      <UpgradeSuccessContainer/>
    </div>
  );
};

export default UpgradeSuccess;
